module.exports = __webpack_public_path__ + "img/sc.ad1bcb4c.svg";